module.exports = "<span>&copy; {{settings.getAppSetting('year')}} - {{ settings.getAppSetting('name') }}</span>"